const PROD_WEBSITE_BASE = "https://heimdall.eka.io/website/";
const PROD_EMPLOYEE_ORIGIN = "https://heimdall.eka.io/";
const SANDBOX_BASE = "https://api-uat-sandbox.eka.io/";
const DEV_BASE = "https://api.dev.eka.io/";
const UAT_BASE = "https://dice-uat.eka.io/";
const JKC_UAT_BASE = "https://api-uat.jkyms.com/website";
const JKC_PROD_BASE = "https://api.jkyms.com/website/";

/**
 * @param {string | undefined} search - `window.location.search` or route search string
 */
function getEnvFromSearch(search) {
	if (typeof window === "undefined" && search === undefined) {
		return null;
	}
	const q = search !== undefined ? search : window.location.search;
	const raw = new URLSearchParams(q).get("env");
	return raw ? raw.trim().toUpperCase() : null;
}

/**
 * Base URL for `/website/*` API calls (axios defaults and explicit URLs).
 */
export function getWebsiteApiBaseUrl(search) {
	const env = getEnvFromSearch(search);
	if (env === "SANDBOX") return SANDBOX_BASE;
	if (env === "DEV") return DEV_BASE;
	if (env === "UAT") return UAT_BASE;
	if (env === "JKC-UAT") return JKC_UAT_BASE;
	if(env === "JKC") return JKC_PROD_BASE;
	return PROD_WEBSITE_BASE;
}

/**
 * Full URL for a website API path (e.g. `task.quote`, `company.details`).
 * When `env` is not set, uses JWT `origin` + `/website/` if provided.
 * @param {string} path - path segment after website base (no leading slash)
 * @param {string} [tokenOrigin] - optional `origin` from decoded action token
 */
export function getWebsiteApiUrl(path, tokenOrigin, search) {
	const env = getEnvFromSearch(search);
	const p = path.replace(/^\//, "");
	if (env === "SANDBOX" || env === "DEV" || env === "UAT") {
		return `${getWebsiteApiBaseUrl(search)}${p}`;
	}
	if (tokenOrigin) {
		const o = tokenOrigin.endsWith("/") ? tokenOrigin.slice(0, -1) : tokenOrigin;
		return `${o}/website/${p}`;
	}
	return `${getWebsiteApiBaseUrl(search)}${p}`;
}

/**
 * Root used for `employee/...` routes. `env` overrides JWT `origin`.
 */
export function resolveActionOrigin(locationSearch, tokenJson) {
	const env = getEnvFromSearch(locationSearch);
	if (env === "SANDBOX" || env === "DEV" || env === "UAT") {
		return getWebsiteApiBaseUrl(locationSearch);
	}
	if (tokenJson && tokenJson.origin) return tokenJson.origin;
	return PROD_EMPLOYEE_ORIGIN;
}

/**
 * Full URL for employee action paths (e.g. `employee/others/action/voucher`).
 */
export function getEmployeeActionUrl(path, tokenOrigin, search) {
	const env = getEnvFromSearch(search);
	const p = path.replace(/^\//, "");
	if (env === "SANDBOX" || env === "DEV" || env === "UAT") {
		return `${getWebsiteApiBaseUrl(search)}${p}`;
	}
	if (tokenOrigin) {
		const o = tokenOrigin.endsWith("/") ? tokenOrigin : `${tokenOrigin}/`;
		return `${o}${p}`;
	}
	return `${PROD_EMPLOYEE_ORIGIN}${p}`;
}

const api = getWebsiteApiBaseUrl();
export { api };
